// Local translations
export const T = {
  en_GB: {
    edit: "Edit",
    actions: "Actions",
    noClientsYet: "No clients yet. Create your first client to get started.",
    deleteClient: "Delete Client",
    deleteConfirmation: (name: string) =>
      `Are you sure you want to delete "${name}"? This action cannot be undone.`,
    delete: "Delete",
    cancel: "Cancel",
    error: "Error",
    failedToDelete: "Failed to delete client",
    ok: "OK",
    yes: "Yes",
    no: "No",
  },
  nb_NO: {
    edit: "Rediger",
    actions: "Handlinger",
    noClientsYet: "Ingen kunder ennå. Opprett din første kunde for å komme i gang.",
    deleteClient: "Slett kunde",
    deleteConfirmation: (name: string) =>
      `Er du sikker på at du vil slette "${name}"? Denne handlingen kan ikke angres.`,
    delete: "Slett",
    cancel: "Avbryt",
    error: "Feil",
    failedToDelete: "Kunne ikke slette kunden",
    ok: "OK",
    yes: "Ja",
    no: "Nei",
  },
} as const;
